export default __webpack_public_path__ + "static/media/tas-table-add.1fc256f6.svg";